/* ARCHER slide-out cart drawer — site-wide, self-contained, DUAL-MODE.
   Replaces the /cart page navigation with a right-side drawer.

   MODE A (Shopify theme): drives the LIVE cart via the AJAX API —
     GET /cart.js, POST /cart/add.js, POST /cart/change.js. It ENHANCES the
     porter-generated product form (form.archer-atc-form) instead of hijacking
     it, so real add-to-cart keeps working. Image/title/price/qty all come from
     the real cart, so there are no hardcoded paths. Checkout → /checkout.
   MODE B (static mirror): no window.Shopify + /cart.js 404s → localStorage demo
     using the single-SKU catalogue below, priced off the market switcher.

   Injected on every page alongside archer-cursor.js. The porter copies this file
   verbatim; both modes ship from one source. */
(function () {
  'use strict';
  if (window.__archerCartInit) return;
  window.__archerCartInit = true;

  var SHOPIFY = !!(window.Shopify && window.Shopify.routes !== undefined) || !!window.Shopify;

  /* ---- mirror-only catalogue (single SKU: The Mask) ---- */
  var PRODUCT = {
    id: 'the-mask',
    name: 'The Mask',
    variant: 'AEROARC IR™ · Full-spectrum LED',
    img: '/Assets/NEW%20PDP/1.webp',
    href: '/archerskin.com/the-mask.html',
    price: { usd: 799, aud: 989, nzd: 1022 }
  };
  var CATALOGUE = { 'the-mask': PRODUCT };
  var BAG_KEY = 'archer_bag';
  var TRIG = '[data-nav-cart], a[href="/cart"], a[href$="/cart"]';

  /* ---- market / money (mirror) ---- */
  function market() {
    try {
      var m = localStorage.getItem('archer-market') || localStorage.getItem('archer_market') || 'aud';
      m = m === 'nz' ? 'nzd' : m === 'au' ? 'aud' : m === 'us' ? 'usd' : m;
      return (m === 'usd' || m === 'nzd') ? m : 'aud';
    } catch (e) { return 'aud'; }
  }
  var CODE = { usd: 'USD', aud: 'AUD', nzd: 'NZD' };
  function money(n, decimals, currency) {
    var code = currency || CODE[market()];
    var v = decimals ? Number(n).toFixed(2) : String(Math.round(n));
    return '$' + v + ' ' + code;
  }

  /* ---- normalized cart shape: {items:[{key,name,variant,img,line,qty}], total, currency, count} ---- */

  /* MODE A: Shopify AJAX cart */
  function shopUrl(p) { return (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root.replace(/\/$/, '') : '') + p; }
  function absImg(u) { return !u ? '' : (u.slice(0, 2) === '//' ? 'https:' + u : u); }
  function fetchShop() {
    return fetch(shopUrl('/cart.js'), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        return {
          items: (c.items || []).map(function (it) {
            var vt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
            return {
              key: it.key,
              name: it.product_title || it.title,
              variant: vt,
              img: absImg(it.image || (it.featured_image && it.featured_image.url) || ''),
              line: it.final_line_price / 100,
              qty: it.quantity
            };
          }),
          total: c.total_price / 100,
          currency: c.currency,
          count: c.item_count
        };
      });
  }
  function addShop(variantId, qty) {
    return fetch(shopUrl('/cart/add.js'), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function (r) { return r.json(); });
  }
  function changeShop(key, qty) {
    return fetch(shopUrl('/cart/change.js'), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  /* MODE B: mirror localStorage cart */
  function readBag() {
    try { var b = JSON.parse(localStorage.getItem(BAG_KEY)); return Array.isArray(b) ? b : []; }
    catch (e) { return []; }
  }
  function writeBag(bag) { try { localStorage.setItem(BAG_KEY, JSON.stringify(bag)); } catch (e) {} }
  function fetchMirror() {
    var bag = readBag(), items = [], total = 0, cur = market();
    bag.forEach(function (l) {
      var p = CATALOGUE[l.id]; if (!p) return;
      var line = p.price[cur] * l.qty; total += line;
      items.push({ key: p.id, name: p.name, variant: p.variant, img: p.img, line: line, qty: l.qty });
    });
    return Promise.resolve({ items: items, total: total, currency: CODE[cur],
      count: bag.reduce(function (n, l) { return n + l.qty; }, 0) });
  }
  function addMirror(id, qty) {
    qty = qty > 0 ? qty : 1;
    var bag = readBag(), row = bag.filter(function (l) { return l.id === id; })[0];
    if (row) row.qty += qty; else bag.push({ id: id, qty: qty });
    writeBag(bag); return Promise.resolve();
  }
  function changeMirror(id, qty) {
    var bag = readBag().map(function (l) { return l.id === id ? { id: id, qty: qty } : l; })
                       .filter(function (l) { return l.qty > 0; });
    writeBag(bag); return Promise.resolve();
  }

  /* ---- unified data layer ---- */
  function getCart() { return SHOPIFY ? fetchShop() : fetchMirror(); }
  function changeQty(key, qty) { return (SHOPIFY ? changeShop(key, qty) : changeMirror(key, qty)).then(refresh); }
  function removeItem(key) { return changeQty(key, 0); }

  /* ---- styles ---- */
  var css = [
    '.archer-bag-scrim{position:fixed;inset:0;z-index:100000;background:rgba(20,20,22,.34);opacity:0;visibility:hidden;transition:opacity .32s ease,visibility 0s linear .32s;}',
    '.archer-bag-scrim.is-open{opacity:1;visibility:visible;transition:opacity .32s ease;}',
    '.archer-bag{position:fixed;top:0;right:0;z-index:100001;height:100%;height:100dvh;width:min(440px,100vw);background:#f7f7f5;color:#1b1b1b;display:flex;flex-direction:column;transform:translateX(100%);transition:transform .42s cubic-bezier(.4,0,.1,1);box-shadow:-18px 0 60px rgba(0,0,0,.10);font-family:"ABCDiatype",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;}',
    '.archer-bag.is-open{transform:translateX(0);}',
    '.archer-bag__head{display:flex;align-items:center;justify-content:space-between;padding:26px 26px 18px;}',
    '.archer-bag__title{font-size:16px;letter-spacing:.01em;color:#8a8a86;font-weight:400;}',
    '.archer-bag__x{appearance:none;background:none;border:0;padding:6px;margin:-6px;cursor:pointer;color:#1b1b1b;line-height:0;}',
    '.archer-bag__x svg{width:17px;height:17px;display:block;}',
    '.archer-bag__body{flex:1 1 auto;overflow-y:auto;padding:0 26px;-webkit-overflow-scrolling:touch;}',
    '.archer-bag__empty{padding:48px 0 8px;color:#6f6f6b;font-size:15px;line-height:1.55;}',
    '.archer-bag__empty a{color:#1b1b1b;text-underline-offset:3px;}',
    '.archer-bag-line{display:grid;grid-template-columns:96px 1fr;gap:18px;padding:16px 0;border-top:1px solid rgba(0,0,0,.07);}',
    '.archer-bag-line:first-child{border-top:0;}',
    '.archer-bag-line__img{width:96px;height:146px;object-fit:contain;background:#f2f1ef;border-radius:2px;}',
    '.archer-bag-line__col{display:flex;flex-direction:column;min-width:0;}',
    '.archer-bag-line__top{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;}',
    '.archer-bag-line__name{font-size:15px;letter-spacing:.01em;}',
    '.archer-bag-line__price{font-size:15px;white-space:nowrap;}',
    '.archer-bag-line__rm{appearance:none;background:none;border:0;padding:4px;margin:-4px -4px 0 0;cursor:pointer;color:#1b1b1b;line-height:0;flex:0 0 auto;}',
    '.archer-bag-line__rm svg{width:13px;height:13px;display:block;}',
    '.archer-bag-line__var{font-size:14px;color:#8a8a86;margin-top:4px;}',
    '.archer-bag-line__qty{display:inline-flex;align-items:center;gap:16px;margin-top:auto;padding-top:16px;}',
    '.archer-bag-line__qty button{appearance:none;background:none;border:0;padding:0;width:18px;height:18px;cursor:pointer;color:#1b1b1b;font-size:19px;line-height:1;display:flex;align-items:center;justify-content:center;}',
    '.archer-bag-line__qty span{font-size:15px;min-width:14px;text-align:center;}',
    '.archer-bag__foot{flex:0 0 auto;padding:20px 26px 24px;border-top:1px solid rgba(0,0,0,.09);}',
    '.archer-bag__row{display:flex;align-items:baseline;justify-content:space-between;padding:6px 0;}',
    '.archer-bag__k{font-size:16px;}',
    '.archer-bag__ship-v{font-size:15px;color:#8a8a86;}',
    '.archer-bag__row--total .archer-bag__k,.archer-bag__row--total .archer-bag__v{font-size:20px;}',
    '.archer-bag__checkout{display:block;width:100%;text-align:center;background:#26262a;color:#fff;font-size:16px;padding:17px;margin:14px 0 12px;border:0;cursor:pointer;text-decoration:none;transition:background .2s ease;font-family:inherit;}',
    '.archer-bag__checkout:hover{background:#111;}',
    '.archer-bag__checkout[aria-disabled="true"]{opacity:.4;pointer-events:none;}',
    '.archer-bag__fine{font-size:12.5px;line-height:1.5;color:#8a8a86;margin:0;}',
    '.archer-bag__fine a{color:#6f6f6b;text-underline-offset:2px;}',
    '.archer-bag.is-busy{cursor:progress;}.archer-bag.is-busy .archer-bag__body{opacity:.55;transition:opacity .15s;}',
    '.archer-bag-count{font-variant-numeric:tabular-nums;}',
    '@media (max-width:480px){.archer-bag{width:100vw;}.archer-bag__head{padding:20px 20px 14px;}.archer-bag__body,.archer-bag__foot{padding-left:20px;padding-right:20px;}}'
  ].join('');

  /* ---- DOM ---- */
  var X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var scrim, panel, body, footRefs = {}, state = { items: [], total: 0, currency: CODE[market()], count: 0 };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function build() {
    var style = document.createElement('style');
    style.id = 'archer-cart-style';
    style.textContent = css;
    document.head.appendChild(style);

    scrim = document.createElement('div');
    scrim.className = 'archer-bag-scrim';

    panel = document.createElement('aside');
    panel.className = 'archer-bag';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Shopping bag');
    panel.innerHTML =
      '<div class="archer-bag__head">' +
        '<span class="archer-bag__title">Bag</span>' +
        '<button class="archer-bag__x" type="button" aria-label="Close bag">' + X + '</button>' +
      '</div>' +
      '<div class="archer-bag__body"></div>' +
      '<div class="archer-bag__foot">' +
        '<div class="archer-bag__row archer-bag__row--ship"><span class="archer-bag__k">Shipping</span><span class="archer-bag__ship-v">FREE</span></div>' +
        '<div class="archer-bag__row archer-bag__row--total"><span class="archer-bag__k">Total</span><span class="archer-bag__v" data-bag-total>$0</span></div>' +
        '<a class="archer-bag__checkout" href="/checkout">Checkout</a>' +
        '<p class="archer-bag__fine">By proceeding to checkout you agree to our ' +
          '<a href="' + termsHref() + '">terms and conditions</a> and ' +
          '<a href="' + privacyHref() + '">privacy policy</a>.</p>' +
      '</div>';

    document.body.appendChild(scrim);
    document.body.appendChild(panel);
    body = panel.querySelector('.archer-bag__body');
    footRefs.total = panel.querySelector('[data-bag-total]');
    footRefs.checkout = panel.querySelector('.archer-bag__checkout');

    scrim.addEventListener('click', close);
    panel.querySelector('.archer-bag__x').addEventListener('click', close);
    body.addEventListener('click', onBodyClick);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* policy links resolve per mode (theme uses page routes; mirror uses .html) */
  function termsHref() { return SHOPIFY ? '/policies/terms-of-service' : '/archerskin.com/policies/terms-of-service.html'; }
  function privacyHref() { return SHOPIFY ? '/policies/privacy-policy' : '/archerskin.com/policies/privacy-policy.html'; }

  function onBodyClick(e) {
    if (panel.classList.contains('is-busy')) return;
    var el = e.target.closest('[data-bag-act]');
    if (!el) return;
    var line = el.closest('[data-bag-id]'); if (!line) return;
    var key = line.getAttribute('data-bag-id');
    var act = el.getAttribute('data-bag-act');
    var row = state.items.filter(function (i) { return i.key === key; })[0];
    var q = row ? row.qty : 0;
    panel.classList.add('is-busy');
    var op = act === 'inc' ? changeQty(key, q + 1)
           : act === 'dec' ? changeQty(key, q - 1)
           : removeItem(key);
    op.catch(function () {}).then(function () { panel.classList.remove('is-busy'); });
  }

  /* ---- render from normalized cart ---- */
  function render(c) {
    state = c || state;
    if (!panel) return;
    if (!state.items.length) {
      var shop = SHOPIFY ? '/products/archerprecisionmask' : PRODUCT.href;
      body.innerHTML = '<p class="archer-bag__empty">Your bag is empty.<br><a href="' + shop + '">Shop The Mask →</a></p>';
    } else {
      body.innerHTML = state.items.map(function (i) {
        return '' +
          '<div class="archer-bag-line" data-bag-id="' + esc(i.key) + '">' +
            (i.img ? '<img class="archer-bag-line__img" src="' + esc(i.img) + '" alt="' + esc(i.name) + '" loading="lazy">' : '<span class="archer-bag-line__img"></span>') +
            '<div class="archer-bag-line__col">' +
              '<div class="archer-bag-line__top">' +
                '<span class="archer-bag-line__name">' + esc(i.name) + '&nbsp;&nbsp;<span class="archer-bag-line__price">' + money(i.line, true, state.currency) + '</span></span>' +
                '<button class="archer-bag-line__rm" type="button" data-bag-act="rm" aria-label="Remove ' + esc(i.name) + '">' + X + '</button>' +
              '</div>' +
              (i.variant ? '<div class="archer-bag-line__var">' + esc(i.variant) + '</div>' : '') +
              '<div class="archer-bag-line__qty">' +
                '<button type="button" data-bag-act="dec" aria-label="Decrease quantity">&minus;</button>' +
                '<span>' + i.qty + '</span>' +
                '<button type="button" data-bag-act="inc" aria-label="Increase quantity">&plus;</button>' +
              '</div>' +
            '</div>' +
          '</div>';
      }).join('');
    }
    footRefs.total.textContent = money(state.total, false, state.currency);
    footRefs.checkout.setAttribute('aria-disabled', state.items.length ? 'false' : 'true');
    renderTriggers(state.count);
  }

  function refresh() { return getCart().then(render); }

  /* count badge on every cart trigger */
  function renderTriggers(n) {
    document.querySelectorAll(TRIG).forEach(function (a) {
      if (!a.hasAttribute('data-bag-label')) a.setAttribute('data-bag-label', a.textContent.trim());
      var base = a.getAttribute('data-bag-label') || 'Cart';
      a.innerHTML = n ? base + ' <span class="archer-bag-count">(' + n + ')</span>' : base;
    });
  }

  /* ---- open / close ---- */
  var scrollY = 0;
  function open() {
    if (!panel) return;
    scrim.classList.add('is-open');
    panel.classList.add('is-open');
    scrollY = window.scrollY;
    document.body.style.top = -scrollY + 'px';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    refresh();
  }
  function close() {
    if (!panel) return;
    scrim.classList.remove('is-open');
    panel.classList.remove('is-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  /* Single-product variant id on the theme, read from the permalink tag the
     porter renders to a number (the same tag the "Shop the mask" link uses).
     Null on the static mirror, where the Liquid tag never renders. */
  function themeVariantId() {
    var el = document.querySelector('[data-checkout-permalink]');
    var id = el ? (el.getAttribute('data-checkout-permalink') || '').trim() : '';
    if (/^\d+$/.test(id)) return id;
    // permalink tag empty (e.g. product handle renamed) → any product form's id
    var input = document.querySelector('form.archer-atc-form [name="id"]');
    var v = input ? (input.value || '').trim() : '';
    return /^\d+$/.test(v) ? v : null;
  }

  /* Reliable single-variant id for an Add-to-Cart element: prefer the porter's
     product-form hidden input (rendered from the page `product` on the PDP, so
     always a valid id), fall back to the permalink tag the "Shop the mask" link
     uses. Null on the static mirror, where no Liquid renders. */
  function variantIdFor(el) {
    var form = el && el.closest ? el.closest('form.archer-atc-form') : null;
    var input = form ? form.querySelector('[name="id"]') : null;
    var v = input ? (input.value || '').trim() : '';
    if (/^\d+$/.test(v)) return v;
    return themeVariantId();
  }

  /* Shopify cart permalink: adds `qty` of the variant and lands straight on
     checkout, carrying the active market (AU → AUD price list → $679 AUD). */
  function goCheckout(vid, qty) { window.location.href = shopUrl('/cart/' + vid + ':' + (qty > 0 ? qty : 1)); }

  /* ---- quantity stepper (PDP buy box: [ − 1 + ]) ---- */
  function qtyBox() { return document.querySelector('[data-qty]'); }
  function readQty() { var b = qtyBox(); var el = b && b.querySelector('[data-qty-val]'); var q = el ? parseInt(el.textContent, 10) : 1; return q > 0 ? q : 1; }
  function setQty(q) {
    q = q > 0 ? q : 1;
    var b = qtyBox(); if (!b) return;
    var el = b.querySelector('[data-qty-val]'); if (el) el.textContent = q;
    var dec = b.querySelector('[data-qty-dec]'); if (dec) dec.disabled = q <= 1;
  }

  /* Add-to-Cart BUTTONS (buy box + sticky bar) jump straight to checkout on the
     live theme; on the static mirror they add + open the drawer. The inline
     "Shop the mask" link keeps the add-then-drawer UX in both modes. The header
     cart icon (TRIG) always opens the drawer so the bag stays reviewable. */
  var CHECKOUT_SEL = '.archer-atc, .archer-sticky-atc__cta';
  var DRAWER_SEL = '[data-checkout-permalink]';

  /* ---- wire triggers ---- */
  function wire() {
    document.addEventListener('click', function (e) {
      // open on any cart link
      var cartLink = e.target.closest(TRIG);
      if (cartLink) { e.preventDefault(); open(); return; }

      // quantity stepper − / +
      var step = e.target.closest('[data-qty-dec],[data-qty-inc]');
      if (step) {
        e.preventDefault();
        setQty(readQty() + (step.hasAttribute('data-qty-inc') ? 1 : -1));
        return;
      }

      // Add-to-Cart buttons → straight to Shopify checkout (live) / drawer (mirror)
      var buy = e.target.closest(CHECKOUT_SEL);
      if (buy) {
        e.preventDefault();
        var qty = readQty();
        if (SHOPIFY) {
          var vid = variantIdFor(buy);
          if (vid) { goCheckout(vid, qty); return; }
          // no resolvable id → let the native product form add + redirect
          var f = buy.closest ? buy.closest('form.archer-atc-form') : null;
          if (f) { f.submit(); }
        } else {
          addMirror(PRODUCT.id, qty).then(open);
        }
        return;
      }

      // "Shop the mask" inline link → add, then open the drawer
      var atc = e.target.closest(DRAWER_SEL);
      if (!atc) return;
      e.preventDefault();
      if (SHOPIFY) {
        var sid = themeVariantId();
        panel.classList.add('is-busy');
        open();
        (sid ? addShop(sid, 1) : Promise.resolve())
          .then(refresh)
          .catch(function () {})
          .then(function () { panel.classList.remove('is-busy'); });
      } else {
        addMirror(PRODUCT.id).then(open);
      }
    });

    // THEME: product-form submit (e.g. Enter key) also goes straight to checkout
    if (SHOPIFY) {
      document.addEventListener('submit', function (e) {
        var form = e.target.closest && e.target.closest('form.archer-atc-form');
        if (!form) return;
        var idInput = form.querySelector('[name="id"]');
        if (!idInput || !idInput.value) return; // let it submit normally if malformed
        e.preventDefault();
        goCheckout(idInput.value.trim(), readQty());
      });
    }

    // re-price mirror when the market switcher changes
    if (!SHOPIFY) {
      document.addEventListener('click', function (e) {
        if (e.target.closest('.archer-switcher-btn')) setTimeout(refresh, 0);
      });
    }
    window.addEventListener('storage', function (e) {
      if (e.key === BAG_KEY || e.key === 'archer-market' || e.key === 'archer_market') refresh();
    });
  }

  /* ---- boot ---- */
  function boot() { build(); wire(); setQty(readQty()); refresh(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.ArcherBag = { open: open, close: close, refresh: refresh,
    add: function (idOrVariant) { return (SHOPIFY ? addShop(idOrVariant, 1) : addMirror(idOrVariant || PRODUCT.id)).then(refresh); } };
})();
